export default __webpack_public_path__ + "static/media/Setoshi-Mask-0031.fbe0d3e7.png";